'use client'

import { MouseEvent } from 'react'
import { Cell, Radio, Spacer, Text } from '@vinted/web-ui'

import { SortByOption } from '@marketplace-web/domain/catalog-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { List } from '@marketplace-web/common-components/list-ui'

import FilterDropdown from '../FilterDropdown'

type Props = {
  selected?: SortByOption
  onItemClick: (value: SortByOption) => void
  onDropdownOpen: () => void
}

const SortFilter = ({ selected = SortByOption.Relevance, onItemClick, onDropdownOpen }: Props) => {
  const translate = useTranslate('user.items.filters.sort')

  const handleItemClick = (id: SortByOption) => (event: MouseEvent) => {
    event.preventDefault()

    onItemClick(id)
  }

  const handleRadioClick = (event: MouseEvent<HTMLInputElement>) => {
    event.stopPropagation()
  }

  const renderDropdownItem = (id: SortByOption) => {
    const isChecked = id === selected

    const title = translate(`options.${id}`)

    return (
      <Cell
        key={id}
        id={`sort_by-list-item-${id}`}
        type={Cell.Type.Navigating}
        body={<Text text={title} type={Text.Type.Title} as="span" />}
        onClick={handleItemClick(id)}
        suffix={
          <Radio
            name="sort_by"
            value={id}
            aria={{ 'aria-labelledby': `sort_by-list-item-${id}` }}
            onChange={() => undefined}
            onClick={handleRadioClick}
            checked={isChecked}
          />
        }
      />
    )
  }

  const renderDropdown = () => (
    <div className="u-ui-padding-vertical-x-small">
      <List>{Object.values(SortByOption).map(renderDropdownItem)}</List>
    </div>
  )

  return (
    <div className="u-flexbox u-align-items-center">
      <Text as="h3" theme="amplified" type={Text.Type.Subtitle} text={translate('name')} />
      <Spacer orientation={Spacer.Orientation.Vertical} />
      <FilterDropdown
        title={translate(`options.${selected}`)}
        placement="bottom-end"
        closeOnClick
        onOpen={onDropdownOpen}
        testId="sort-filter-dropdown"
      >
        {renderDropdown()}
      </FilterDropdown>
    </div>
  )
}

export default SortFilter
